import { render, staticRenderFns } from "./BrandsIntroduction.vue?vue&type=template&id=73a2c513&scoped=true&"
import script from "./BrandsIntroduction.vue?vue&type=script&lang=ts&"
export * from "./BrandsIntroduction.vue?vue&type=script&lang=ts&"
import style0 from "./BrandsIntroduction.vue?vue&type=style&index=0&id=73a2c513&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a2c513",
  null
  
)

export default component.exports